import { resolveProductUrl } from "@podus/utils";

const ALLOWED_DOMAINS = [
  "localhost",
  "podus.ai",
  "www.podus.ai",
  "chat.podus.ai",
  "contract.podus.ai",
  "app.podus.ai",
  "appointment.podus.ai",
  "checker.podus.org",
  "app.podus.org",
  "podus.org",
  "www.podus.org",
  "harmlist.com",
  "www.harmlist.com",
  "ipvp.citizensgavel.org",
];

export function isAllowedRedirect(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ALLOWED_DOMAINS.includes(parsed.hostname);
  } catch {
    return false;
  }
}

export function buildRedirectUrl(baseUrl: string, token: string, userId?: string): string {
  const resolved = resolveProductUrl(baseUrl);
  const url = new URL(resolved);
  url.searchParams.set("accessToken", token);
  if (userId) url.searchParams.set("uid", userId);
  return url.toString();
}
